import { useNavigate, useParams } from 'react-router'
import { LinkAsk } from '@/components/people/LinkAsk'
import { useRefreshConnections } from '@/lib/connections'
import { usePageFrame } from '@/lib/frame'

// Someone's connect link, opened: whose it is and who you both know, and a way to ask. They still say yes.
export function ConnectLinkPage() {
  const { token = '' } = useParams()
  usePageFrame(undefined, { title: 'Connect', back: { to: '/', label: 'Back' } })
  const refresh = useRefreshConnections()
  const navigate = useNavigate()
  return (
    <section className="mx-auto flex w-full max-w-sm flex-col gap-6 py-4">
      <p className="text-center eyebrow">Connect</p>
      <LinkAsk
        token={token}
        page
        onDone={() => {
          void refresh()
          navigate('/people')
        }}
      />
    </section>
  )
}
